// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Employee, plan, and tax year combination for IRS limits search
 * @export
 * @interface IEmployeePlanTaxYearRequest
 */
export interface IEmployeePlanTaxYearRequest {
    /**
     * Employee ID
     * @type {number}
     * @memberof IEmployeePlanTaxYearRequest
     */
    employee_id: number;
    /**
     * Plan ID
     * @type {number}
     * @memberof IEmployeePlanTaxYearRequest
     */
    plan_id: number;
    /**
     * Tax year
     * @type {number}
     * @memberof IEmployeePlanTaxYearRequest
     */
    tax_year: number;
}

/**
 * Check if a given object implements the IEmployeePlanTaxYearRequest interface.
 */
export function instanceOfIEmployeePlanTaxYearRequest(value: object): value is IEmployeePlanTaxYearRequest {
    if (!('employee_id' in value) || value['employee_id'] === undefined) return false;
    if (!('plan_id' in value) || value['plan_id'] === undefined) return false;
    if (!('tax_year' in value) || value['tax_year'] === undefined) return false;
    return true;
}

export function IEmployeePlanTaxYearRequestFromJSON(json: any): IEmployeePlanTaxYearRequest {
    return IEmployeePlanTaxYearRequestFromJSONTyped(json, false);
}

export function IEmployeePlanTaxYearRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): IEmployeePlanTaxYearRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'employee_id': json['employee_id'],
        'plan_id': json['plan_id'],
        'tax_year': json['tax_year'],
    };
}

export function IEmployeePlanTaxYearRequestToJSON(json: any): IEmployeePlanTaxYearRequest {
    return IEmployeePlanTaxYearRequestToJSONTyped(json, false);
}

export function IEmployeePlanTaxYearRequestToJSONTyped(value?: IEmployeePlanTaxYearRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employee_id': value['employee_id'],
        'plan_id': value['plan_id'],
        'tax_year': value['tax_year'],
    };
}

